import styled from "styled-components";
import { mobile, tablet } from "../responsive";
import { toast, ToastContainer } from "react-toastify";
import emailjs from "@emailjs/browser";
import "react-toastify/dist/ReactToastify.css";
import Footer from "../components/Footer";
import Announcement from "../components/Announcement";
import Newsletter from "../components/Newsletter";
import { useRef, useEffect } from "react";
import { LocationOn, Mail, Phone, AccountBalance } from "@material-ui/icons";
import { FormattedMessage } from "react-intl";

const Container = styled.div`
    width: 100vw;
    height: 100vh;
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.1) 30%, rgba(68, 94, 79, 0.1) 50%, rgba(0, 0, 0, 0.3) 100%),
        url("https://ik.imagekit.io/dnddecpho/airvitamin/fillerbg_Y_7yHWnKH?updatedAt=1732806058393")
            center;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    ${mobile({ display: "block", height: "100%", background: "none" })}
    ${tablet({ display: "block", height: "100%", background: "none" })}
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 450px;
    margin: 5rem;
    width: 40%;
    padding: 16px 32px;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 20px;
    box-shadow: 0 25px 45px -12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(255, 255, 255, 0.05);
    min-width: 300px;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 35px 60px -12px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.1);
    }

    ${mobile({
        width: "90%",
        margin: "0rem",
        height: "100%",
        padding: "3rem 1rem",
        borderRadius: "15px",
    })}
    ${tablet({
        width: "90%",
        margin: "0rem",
        height: "100%",
        padding: "3rem 1rem",
        borderRadius: "15px",
    })}
`;

const Title = styled.h1`
    font-size: 1.8rem;
    color:rgb(0, 0, 0);
    display: flex;
    align-items: center;
    font-family: Jost-Bold;
    margin-bottom: 1.5rem;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);

    &::after {
        content: '';
        flex: 1;
        height: 2px;
        background: linear-gradient(90deg, #374836 0%, #445E4F 50%, transparent 100%);
        margin-left: 1rem;
        border-radius: 1px;
    }
`;

const Form = styled.form`
    display: flex;
    flex-wrap: wrap;
    ${mobile({ display: "flex", flexDirection: "column" })}
    ${tablet({ display: "flex", flexDirection: "column" })}
`;

const Input = styled.input`
    font-family: Jost-SemiBold;
    flex: 1;
    min-width: 40%;
    margin: 20px 10px 0px 0px;
    padding: 14px 18px;
    border: 2px solid rgba(55, 72, 54, 0.2);
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);
    font-size: 1rem;
    transition: all 0.3s ease;
    outline: none;

    &::placeholder {
        color: #666;
        font-weight: 400;
    }

    &:focus {
        border-color: #374836;
        background: rgba(255, 255, 255, 0.95);
        box-shadow: 0 0 0 3px rgba(55, 72, 54, 0.1);
    }
`;

const PhoneInput = styled.input`
    font-family: Jost-SemiBold;
    flex: 1;
    min-width: 90%;
    margin: 20px 10px 0px 0px;
    padding: 14px 18px;
    border: 2px solid rgba(55, 72, 54, 0.2);
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);
    font-size: 1rem;
    transition: all 0.3s ease;
    outline: none;

    &::placeholder {
        color: #666;
        font-weight: 400;
    }

    &:focus {
        border-color: #374836;
        background: rgba(255, 255, 255, 0.95);
        box-shadow: 0 0 0 3px rgba(55, 72, 54, 0.1);
    }
`;

const MessageInput = styled.input`
    font-family: Jost-SemiBold;
    flex: 1;
    min-width: 90%;
    margin: 20px 10px 0px 0px;
    padding: 30px 18px;
    border: 2px solid rgba(55, 72, 54, 0.2);
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);
    font-size: 1rem;
    transition: all 0.3s ease;
    outline: none;
    resize: vertical;
    min-height: 120px;

    &::placeholder {
        color: #666;
        font-weight: 400;
    }

    &:focus {
        border-color: #374836;
        background: rgba(255, 255, 255, 0.95);
        box-shadow: 0 0 0 3px rgba(55, 72, 54, 0.1);
    }
`;

const Agreement = styled.span`
    font-family: Jost-SemiBold;
    font-size: 14px;
    margin: 20px 0px;
    color:rgb(0, 0, 0);
    line-height: 1.5;
    opacity: 0.8;
`;

const Button = styled.button`
    width: 40%;
    border: none;
    padding: 15px 20px;
    margin-bottom: 1rem;
    background: linear-gradient(135deg, #374836 0%, #445E4F 100%);
    color: white;
    cursor: pointer;
    font-family: Jost-Bold;
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 600;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(55, 72, 54, 0.3);
    text-transform: uppercase;
    letter-spacing: 0.5px;

    &:hover {
        background: linear-gradient(135deg, #445E4F 0%, #374836 100%);
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(55, 72, 54, 0.4);
    }

    &:active {
        transform: translateY(0);
    }

    ${mobile({ width: "70vw" })}
    ${tablet({ width: "70vw" })}
`;

const InfoWrapper = styled.div`
    min-height: 450px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin: 5rem;
    width: 40%;
    padding: 16px 32px;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 20px;
    box-shadow: 0 25px 45px -12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(255, 255, 255, 0.05);
    min-width: 300px;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 35px 60px -12px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.1);
    }

    ${mobile({
        width: "90%",
        margin: "0rem",
        height: "100%",
        padding: "3rem 1rem",
        borderRadius: "15px",
    })}
    ${tablet({
        width: "90%",
        margin: "0rem",
        height: "100%",
        padding: "3rem 1rem",
        borderRadius: "15px",
    })}
`;


const Desc = styled.h3`
    font-family: Jost-SemiBold;
    color:rgb(0, 0, 0);
    font-size: 16px;
    font-weight: 400;
    line-height: 1.6;
    margin: 0.5rem 0;
    opacity: 0.9;
    ${mobile({ padding: "0" })}
    ${tablet({ padding: "0" })}
`;

const InfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 1.2rem 0;
    margin-bottom: 1.5rem;
    border-bottom: 1px solid rgba(55, 72, 54, 0.1);

    &:last-child {
        border-bottom: none;
        margin-bottom: 0;
    }

    ${mobile({ padding: "1rem 0" })}
    ${tablet({ padding: "1rem 0" })}
`;


const SERVICE_ID = "service_gl7n2ar";
const TEMPLATE_ID = "template_blknfw7";
const USER_ID = "2oRXHzBAa8pjFRl2z";

const Contact = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const form = useRef();
    const handleOnSubmit = (e) => {
        e.preventDefault();
        emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, form.current, USER_ID).then(
            (result) => {
                toast.success(
                    "We have successfully received your email, Please be patient as we get back to you as soon as possible!",
                    {
                        position: "top-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    }
                );
            },
            (error) => {
                console.log(error.text);
                toast.error("Failed", {
                    position: "top-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        );
        e.target.reset();
    };

    return (
        <>
            <Announcement />
            <Container>
                <Wrapper>
                    <Title><FormattedMessage id="contact_title" defaultMessage="" /></Title>
                    <Form ref={form} onSubmit={handleOnSubmit}>
                        <Input
                            id="grid-first-name"
                            placeholder="First Name"
                            name="firstName"
                        />
                        <Input
                            id="grid-last-name"
                            placeholder="Last Name"
                            name="lastName"
                        />
                        <PhoneInput
                            id="grid-number"
                            placeholder="Phone Number"
                            name="phoneNumber"
                        />
                        <MessageInput
                            id="grid-message"
                            placeholder="Enter your message here"
                            name="message"
                        />
                        <Agreement>
                        <FormattedMessage id="contact_agreement" defaultMessage="" />
                        </Agreement>
                        <Button><FormattedMessage id="contact_button" defaultMessage="" /></Button>
                        <ToastContainer
                            style={{ width: "fit-content", overflow: "hidden" }}
                            position="top-center"
                            autoClose={5000}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />
                    </Form>
                </Wrapper>
                <InfoWrapper>
                    <InfoContainer>
                        <Title>
                            <Mail
                                style={{
                                    marginRight: "1rem",
                                    color: "#374836",
                                    fontSize: "1.5rem",
                                }}
                            ></Mail>{" "}
                            <FormattedMessage id="contact_subtitle_1" defaultMessage="" />
                        </Title>
                        <Desc>mgtairvitamin@gmail.com</Desc>
                    </InfoContainer>
                    <InfoContainer>
                        <Title>
                            <Phone
                                style={{
                                    marginRight: "1rem",
                                    color: "#374836",
                                    fontSize: "1.5rem",
                                }}
                            ></Phone>{" "}
                           <FormattedMessage id="contact_subtitle_2" defaultMessage="" />
                        </Title>
                        <Desc>
                            012 334 8626
                        </Desc>
                    </InfoContainer>
                    <InfoContainer>
                        <Title>
                            <LocationOn
                                style={{
                                    marginRight: "1rem",
                                    color: "#374836",
                                    fontSize: "1.5rem",
                                }}
                            ></LocationOn>{" "}
                          <FormattedMessage id="contact_subtitle_3" defaultMessage="" />
                        </Title>
                        <Desc>
                        MGT VITAMIN RESEARCH AND DEVELOPMENT
                        </Desc>
                    </InfoContainer>
                    <InfoContainer>
                        <Title>
                            <AccountBalance
                                style={{
                                    marginRight: "1rem",
                                    color: "#374836",
                                    fontSize: "1.5rem",
                                }}
                            ></AccountBalance>{" "}
                            <FormattedMessage id="contact_subtitle_4" defaultMessage="" />
                        </Title>
                        <Desc>
                            3208 2215 29 (Public Bank)
                        </Desc>
                    </InfoContainer>
                </InfoWrapper>
            </Container>
            <Newsletter></Newsletter>
            <Footer></Footer>
        </>
    );
};

export default Contact;
